export const TERM_AND_SERVICES_URL = '/terms';
export const DISCLAIMER_URL = '/disclaimer';
export const PRIVACY_POLICY_URL = '/privacy-policy';
export const ROADMAP_URL = '/roadmap';
export const DISCORD_URL = '/discord';
export const TWITTER_URL = '/twitter';
export const OPENSEA_URL = '/openSea';
